import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';



@NgModule({
  declarations: [
    HelpDialogComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    HelpDialogComponent
  ],
  providers: [
    HelpDialogComponent,
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ]
})
export class HelpModule { }
